import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { createPathWithActivity } from "@outschool/routes";
import { useProductClicked } from "@outschool/ui-analytics";
import {
  Carousel,
  TrackingProperties
} from "@outschool/ui-legacy-component-library";
import React from "react";

import * as CardDefinition from "../../../../shared/parentDashboard/CardDefinition";
import MiniListing from "../../listings/MiniListing";
import CardLink from "./CardLink";

export default function CardClassList({
  listings,
  id,
  trackingProperties
}: {
  listings: CardDefinition.CardListing[];
  id: string;
  trackingProperties: TrackingProperties;
}) {
  const { t } = useTranslation("client\\components\\parentDashboard\\cards");

  if (listings.length === 0) {
    return <Box>{t("No classes found")}</Box>;
  } else {
    return (
      <GridVariant
        id={id}
        listings={listings}
        trackingProperties={trackingProperties}
      />
    );
  }
}

function GridVariantListing({
  id,
  listing,
  trackingProperties
}: {
  id: string;
  listing: CardDefinition.CardListing;
  trackingProperties: TrackingProperties;
}) {
  const trackProductClicked = useProductClicked();

  return (
    <Box
      sx={{
        width: "70vw"
      }}
    >
      <CardLink
        url={createPathWithActivity(listing.activity)}
        id={id}
        onClick={() => trackProductClicked(listing)}
        trackingProperties={{
          ...trackingProperties,
          cardLocation: "listing",
          activityUid: listing.activity.uid,
          insertion_id: listing.insertionId
        }}
      >
        <MiniListing
          key={listing.activity.uid}
          listing={{
            ...listing,
            insertionId: listing.insertionId ?? undefined
          }}
        />
      </CardLink>
    </Box>
  );
}

function GridVariant({
  id,
  listings,
  trackingProperties
}: {
  id: string;
  listings: CardDefinition.CardListing[];
  trackingProperties: TrackingProperties;
}) {
  const displayedListings = listings.slice(0, 12);
  const numRows = Math.min(displayedListings.length, 3);

  return (
    <Carousel sx={{ marginX: "-48px" }} innerSx={{ justifyContent: "stretch" }}>
      <Box
        sx={{
          marginX: "48px",
          display: "grid",
          gridTemplateRows: `repeat(${numRows}, 1fr)`,
          gridAutoColumns: "70vw",
          gridAutoFlow: "column",
          gap: "10px",
          wordBreak: "break-word"
        }}
      >
        {displayedListings.map((listing: CardDefinition.CardListing) => (
          <GridVariantListing
            key={listing.activity.uid}
            id={id}
            listing={listing}
            trackingProperties={trackingProperties}
          />
        ))}
      </Box>
    </Carousel>
  );
}
